const openCard = () => import('@/views/main/order/open-card/open-card.vue')
export default {
  path: '/main/order/openCard',
  name: 'openCard',
  component: openCard,
  children: []
}
